module.exports = __webpack_public_path__ + "static/16.2_Early_Middle_Ages-57e2dbcb0ae835914d6d7f30a4352488.pdf";